import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export const RuleProductIcon = (props) => (<SvgIcon viewBox="0 0 16 16" {...props}>
    <path d="M2.5 4H13.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 8H13.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 12H9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.5 12H14.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13 10.5V13.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>);
export default RuleProductIcon;
